import { render } from "./InstructionsComponent.vue?vue&type=template&id=2ab25402&scoped=true"
import script from "./InstructionsComponent.vue?vue&type=script&lang=js"
export * from "./InstructionsComponent.vue?vue&type=script&lang=js"

import "./InstructionsComponent.vue?vue&type=style&index=0&id=2ab25402&scoped=true&lang=css"

import exportComponent from "C:\\Users\\anton\\Desktop\\cangas_de_narcea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab25402"]])

export default __exports__